var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.importing
        ? _c(
            "div",
            [
              _c("v-file-input", {
                on: { change: _vm.importXlsx },
                model: {
                  value: _vm.uploadedFile,
                  callback: function ($$v) {
                    _vm.uploadedFile = $$v
                  },
                  expression: "uploadedFile",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.uploadedFile
        ? _c(
            "div",
            [_c("ImportEditor", { attrs: { file: _vm.uploadedFile } })],
            1
          )
        : _c(
            "card",
            {
              attrs: { title: _vm.$t("models.company.selves") },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          attrs: { small: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.xls()
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("fa fa-download"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("actions.export")) + " "),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          attrs: { small: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.importing = true
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("fa fa-upload"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("actions.import")) + " "),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.createCompany()
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("fa fa-plus"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("Create a company")) + " "
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              [
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-row",
                      { staticClass: "mb-2" },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                multiple: "",
                                items: _vm.countries,
                                label: _vm.$t("models.country.self"),
                                "item-text": function (item) {
                                  return item.name != "null" &&
                                    item.code != null
                                    ? _vm.translate(item.name) +
                                        ": (" +
                                        item.code +
                                        ")"
                                    : "" + _vm.translate(item.name)
                                },
                                "item-value": "id",
                              },
                              on: { change: _vm.onChangeCountry },
                              model: {
                                value: _vm.countryFilterId,
                                callback: function ($$v) {
                                  _vm.countryFilterId = $$v
                                },
                                expression: "countryFilterId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                multiple: "",
                                items: _vm.sectors,
                                label: _vm.$t("models.sector.self"),
                                "item-text": function (item) {
                                  return item.name != "null" &&
                                    item.domain != null
                                    ? _vm.translate(item.name) +
                                        ": (" +
                                        item.domain +
                                        ")"
                                    : "" + _vm.translate(item.domain)
                                },
                                "item-value": "id",
                              },
                              on: { change: _vm.onChangeSector },
                              model: {
                                value: _vm.sectorId,
                                callback: function ($$v) {
                                  _vm.sectorId = $$v
                                },
                                expression: "sectorId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                multiple: "",
                                items: _vm.availableYears,
                                label: _vm.$t("availableYearsFull"),
                                "item-text": function (item) {
                                  return item.name != "null" &&
                                    item.domain != null
                                    ? _vm.translate(item.name) +
                                        ": (" +
                                        item.domain +
                                        ")"
                                    : "" + _vm.translate(item.domain)
                                },
                                "item-value": "id",
                              },
                              on: { change: _vm.onChangeAvailableYears },
                              model: {
                                value: _vm.availableYearsIds,
                                callback: function ($$v) {
                                  _vm.availableYearsIds = $$v
                                },
                                expression: "availableYearsIds",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                multiple: "",
                                items: _vm.availableYearsSmart,
                                label: _vm.$t("availableYearsSmart"),
                                "item-text": function (item) {
                                  return item.name != "null" &&
                                    item.domain != null
                                    ? _vm.translate(item.name) +
                                        ": (" +
                                        item.domain +
                                        ")"
                                    : "" + _vm.translate(item.domain)
                                },
                                "item-value": "id",
                              },
                              on: { change: _vm.onChangeAvailableYearsSmart },
                              model: {
                                value: _vm.availableYearsSmartIds,
                                callback: function ($$v) {
                                  _vm.availableYearsSmartIds = $$v
                                },
                                expression: "availableYearsSmartIds",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              _c("grid-view", {
                ref: "grid",
                attrs: {
                  headers: _vm.headers,
                  endpoint: _vm.endpoint,
                  "single-select": false,
                  model: "company",
                },
                on: {
                  "data-loaded": _vm.handleDataLoaded,
                  "endpoint-updated": _vm.handleEndpointUpdated,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.enabled",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.enabled
                          ? _c(
                              "v-icon",
                              { attrs: { small: "", color: "green" } },
                              [_vm._v("fa fa-check")]
                            )
                          : _vm._e(),
                        !item.enabled
                          ? _c(
                              "v-icon",
                              { attrs: { small: "", color: "red" } },
                              [_vm._v("fa fa-times")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.name",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm.isTruncated(item.name)
                          ? _c(
                              "span",
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", color: "black" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  _vm._b(
                                                    {},
                                                    "span",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.truncateText(
                                                          item.name
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_c("span", [_vm._v(_vm._s(item.name))])]
                                ),
                              ],
                              1
                            )
                          : _c("span", [_vm._v(" " + _vm._s(item.name) + " ")]),
                      ]
                    },
                  },
                  {
                    key: "item.companyActivities",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm.isTruncated(
                          _vm.translate(
                            item.companyActivities[0].activity.sector.name
                          )
                        )
                          ? _c(
                              "span",
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "", color: "black" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  _vm._b(
                                                    {},
                                                    "span",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.truncateText(
                                                          _vm.translate(
                                                            item
                                                              .companyActivities[0]
                                                              .activity.sector
                                                              .name
                                                          )
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            item.companyActivities[0].activity
                                              .sector.name
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.translate(
                                      item.companyActivities[0].activity.sector
                                        .name
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "item.country.name",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.translate(item.country.name)) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.legalTypology.name",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.translate(item.legalTypology.name)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.availableYearsFull",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.availableYearsFull.length === 0
                          ? [_c("i", [_vm._v("no data")])]
                          : item.availableYearsFull.length === 1
                          ? [_vm._v(_vm._s(item.availableYearsFull[0]))]
                          : [
                              _vm._v(
                                _vm._s(item.availableYearsFull[0]) +
                                  " — " +
                                  _vm._s(
                                    item.availableYearsFull[
                                      item.availableYearsFull.length - 1
                                    ]
                                  ) +
                                  " "
                              ),
                            ],
                      ]
                    },
                  },
                  {
                    key: "item.availableYearsSmart",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.availableYearsSmart.length === 0
                          ? [_c("i", [_vm._v("no data")])]
                          : item.availableYearsSmart.length === 1
                          ? [_vm._v(_vm._s(item.availableYearsSmart[0]))]
                          : [
                              _vm._v(
                                _vm._s(item.availableYearsSmart[0]) +
                                  " — " +
                                  _vm._s(
                                    item.availableYearsSmart[
                                      item.availableYearsSmart.length - 1
                                    ]
                                  ) +
                                  " "
                              ),
                            ],
                      ]
                    },
                  },
                  {
                    key: "item.web",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.web
                          ? _c(
                              "v-icon",
                              { attrs: { small: "", color: "green" } },
                              [_vm._v("fa fa-check")]
                            )
                          : _vm._e(),
                        !item.web
                          ? _c(
                              "v-icon",
                              { attrs: { small: "", color: "red" } },
                              [_vm._v("fa fa-times")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item._actions",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.viewCompany(item)
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-eye"),
                            ]),
                          ],
                          1
                        ),
                        _vm.user.role == "admin"
                          ? [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.activateCompany(item)
                                    },
                                  },
                                },
                                [
                                  item.enabled
                                    ? _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("fa fa-unlock-alt"),
                                      ])
                                    : _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("fa fa-lock"),
                                      ]),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm.user.role == "admin" && item.financial_status === 0
                          ? [
                              _c(
                                "v-tooltip",
                                {
                                  staticClass: "text-center",
                                  attrs: { top: "", color: "black" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "red lighten-1",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "fa fa-exclamation-triangle"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(item.name) +
                                            " - " +
                                            _vm._s(item.symbol)
                                        ),
                                      ]),
                                      _c("br"),
                                      _c("span", [
                                        _vm._v("financial state has issues."),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600" },
          model: {
            value: _vm.editDialog,
            callback: function ($$v) {
              _vm.editDialog = $$v
            },
            expression: "editDialog",
          },
        },
        [
          _vm.editDialog
            ? _c("export-form", { on: { save: _vm.onDialogSave } })
            : _vm._e(),
        ],
        1
      ),
      _c("v-dialog", {
        attrs: { "max-width": "600" },
        model: {
          value: _vm.editDialog,
          callback: function ($$v) {
            _vm.editDialog = $$v
          },
          expression: "editDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }